function record(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null ? (value as Record<string, unknown>) : null
}

/** Identity reason keys (`messages[0]`) the pairing routes return. */
const REASON_MESSAGES: Readonly<Record<string, string>> = {
  pairing_not_found: 'That pairing no longer exists. Generate a new code.',
  pairing_expired: 'That pairing code expired. Generate a new code.',
  pairing_not_claimable: 'That pairing code was already used. Generate a new code.'
}

const REASON_KEY = /^[a-z0-9]+(_[a-z0-9]+)+$/

/**
 * Readable message from an identity RTK error (`{ message, reason, status }`,
 * where v2 puts `messages[0]` in both). Known reason keys map to copy; other
 * machine keys fall back to `fallback` rather than leaking `snake_case`.
 */
export function devicePairingErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message) return error.message
  const payload = record(error)
  for (const key of ['message', 'reason'] as const) {
    const value = payload?.[key]
    if (typeof value !== 'string' || !value.trim()) continue
    const text = value.trim()
    if (REASON_MESSAGES[text]) return REASON_MESSAGES[text]
    if (!REASON_KEY.test(text)) return text
  }
  return fallback
}
